export default __webpack_public_path__ + "static/media/films.3de8d7fa.png";